import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const BrandingCtx = createContext(null);

export function BrandingProvider({ children }) {
  const [config, setConfig] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await http.get("/public/config");
      setConfig(data);
    } catch (e) {
      const blocked = e.response?.status === 500 ? { system_online: false } : {};
      setConfig((c) => ({ ...(c || { org_name: "Central de Atendimento Rewards", contact_slots: [], primary_color: "#C5A059", background_color: "#0A0F1D" }), ...blocked }));
    }
  }, []);

  useEffect(() => {
    reload();
    const t = setInterval(reload, 20000);
    return () => clearInterval(t);
  }, [reload]);

  useEffect(() => {
    if (!config) return;
    const root = document.documentElement;
    root.style.setProperty("--brand", config.primary_color || "#C5A059");
    root.style.setProperty("--brand-bg", config.background_color || "#0A0F1D");
    document.title = `${config.org_name} · Rewards`;
  }, [config]);

  return <BrandingCtx.Provider value={{ config, reload }}>{children}</BrandingCtx.Provider>;
}

export const useBranding = () => useContext(BrandingCtx);
